<template>
  <div class="box">
    <img :src="require('@/assets/021516101528.jpeg')">
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style lang="scss" scoped>
/* stylelint-disable font-family-no-missing-generic-family-keyword, selector-pseudo-element-no-unknown */
div,
p,
span {
  font-family: prompt;
}

.box {
  img {
    width: 100%;
  }
}

.h-title {
  font-size: 32px;
  line-height: 42px;
  font-family: prompt;
  text-align: center;
  font-weight: bold;
}

.h2-title {
  font-size: 28px;
  font-weight: bold;
  line-height: 40px;
  font-family: prompt;
  text-align: left;
  margin-top: 20px;
}

.p-box {
  padding-left: 20px;
  margin-top: 15px;
}

.p-box p {
  text-align: left;
  text-indent: 40px;
  line-height: 20px;
  font-size: 20px;
}
/* stylelint-enable */
</style>
